import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputFieldComponent } from '../../../../../../components/ui/inputField/inputField.component';
import { NgxMatInputTelComponent } from 'ngx-mat-input-tel';
import { validPhoneNumberValidator } from '../../../../../../../utils/utils';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { formatCount } from '../../../../../../../utils/sms';

/**
 * Ways to add recipients: type a number, upload a file, or open one of the
 * pickers (contacts, tags, organizations, segments). What has been chosen is
 * listed underneath by <create-message-preview>.
 */
@Component({
  selector: 'create-message-select-recipient',
  standalone: true,
  imports: [InputFieldComponent, NgxMatInputTelComponent, ReactiveFormsModule],
  templateUrl: './select-recipient.component.html',
  styleUrl: './select-recipient.component.css',
})
export class SelectRecipientComponent {
  constructor(private builder: FormBuilder) {}

  // data
  @Input() phoneNumberCount: number = 0;
  @Input() contactsCount: number = 0;
  @Input() organizationsCount: number = 0;
  @Input() tagsCount: number = 0;
  @Input() segmentsCount: number = 0;
  /** Files uploaded so far. */
  @Input() csvFileCount: number = 0;
  /** The message was submitted with no recipients at all. */
  @Input() missing: boolean = false;

  // recipient selection modal control
  @Output() openSelectContactsModalEvent = new EventEmitter();
  @Output() openSelectTagsModalEvent = new EventEmitter();
  @Output() openSelectOrganizationsModalEvent = new EventEmitter();
  @Output() openSelectSegmentModalEvent = new EventEmitter();
  @Output() emitPhoneNumberAdded = new EventEmitter<string>();
  @Output() openCSVPhoneNumbersModalEvent = new EventEmitter();

  formatCount = formatCount;

  // phone number form manipulations
  phoneNumberForm = this.builder.group({
    phoneNumber: ['', [Validators.required, validPhoneNumberValidator]],
  });
  phoneNumberSubmitted: boolean = false;

  /** "3 chosen" or the prompt shown before anything is picked. */
  chosen(count: number, prompt: string): string {
    return count ? `${formatCount(count)} chosen` : prompt;
  }

  addPhoneNumber() {
    this.phoneNumberSubmitted = true;
    if (this.phoneNumberForm.valid && this.phoneNumberSubmitted) {
      const phoneNumber = this.phoneNumberForm.value.phoneNumber;
      this.emitPhoneNumberAdded.emit(phoneNumber!);
      // A blank string would leave the old number on screen: the phone input
      // ignores empty writes, so a single space clears it.
      this.phoneNumberForm.reset({
        phoneNumber: ' ',
      });
      this.phoneNumberSubmitted = false;
    }
  }
}
